import * as React from "react";

import SvgIcon from "@material-ui/core/SvgIcon";
import { SvgIconProps } from "@material-ui/core/SvgIcon";

export const ReportCardIcon = (props: SvgIconProps) => {
    const {
        width = "24",
        height = "24",
        viewBox = "0 0 24 24",
        ...rest
    } = props;

    return (
        <SvgIcon
            width={width}
            height={height}
            viewBox={viewBox}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.4859 5.63672L15.4271 2.52324C15.099 2.18926 14.6542 2 14.1911 2H6.75C5.78385 2.00371 5 2.80156 5 3.78496V19.2225C5 20.2059 5.78385 21.0037 6.75 21.0037H17.25C18.2161 21.0037 19 20.2059 19 19.2225V6.89844C19 6.42715 18.8141 5.9707 18.4859 5.63672ZM17.662 6.4791C17.7385 6.55703 17.7896 6.64981 17.8151 6.75371H14.3333V3.20977C14.4354 3.23574 14.5266 3.2877 14.6031 3.36563L17.662 6.4791ZM17.25 19.8162H6.75C6.42917 19.8162 6.16667 19.549 6.16667 19.2225V3.78496C6.16667 3.4584 6.42917 3.19121 6.75 3.19121H13.1667V7.05059C13.1667 7.54414 13.5568 7.94121 14.0417 7.94121H17.8333V19.2225C17.8333 19.549 17.5708 19.8162 17.25 19.8162ZM8.43333 10.6L7.73333 9.9L7.5 10.1333L8.43333 11.0667L10.4333 9.06667L10.2 8.83333L8.43333 10.6ZM7.73333 12.9L8.43333 13.6L10.2 11.8333L10.4333 12.0667L8.43333 14.0667L7.5 13.1333L7.73333 12.9ZM8.43333 16.6L7.73333 15.9L7.5 16.1333L8.43333 17.0667L10.4333 15.0667L10.2 14.8333L8.43333 16.6ZM11.5 10C11.2239 10 11 10.2239 11 10.5C11 10.7761 11.2239 11 11.5 11H16.5C16.7761 11 17 10.7761 17 10.5C17 10.2239 16.7761 10 16.5 10H11.5ZM11 13.5C11 13.2239 11.2239 13 11.5 13H16.5C16.7761 13 17 13.2239 17 13.5C17 13.7761 16.7761 14 16.5 14H11.5C11.2239 14 11 13.7761 11 13.5ZM11.5 16C11.2239 16 11 16.2239 11 16.5C11 16.7761 11.2239 17 11.5 17H16.5C16.7761 17 17 16.7761 17 16.5C17 16.2239 16.7761 16 16.5 16H11.5Z"
                fill="#21006E"
            />
        </SvgIcon>
    );
};
